import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const dataMenu = [
  {
    id: 1,
    title: "Home",
    tag: "welcoming",
  },
  {
    id: 2,
    title: "Our Projects",
    tag: "ourProjects",
  },
  {
    id: 3,
    title: "Our Services",
    tag: "ourServices",
  },
  {
    id: 4,
    title: "Contact",
    tag: "contact",
  },
];

const MenuNavbar = ({ moveTo }) => {
  const [active, setActive] = useState(1);

  const location = useLocation();

  useEffect(() => {
    location.pathname === "/" ? setActive(1) : setActive(0);
  }, [location.pathname]);

  const handleClick = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };

  const handleItem = (tag) => {
    switch (tag) {
      case "welcoming":
        return moveTo[0];
      case "ourProjects":
        return moveTo[1];
      case "ourServices":
        return moveTo[2];
      case "contact":
        return moveTo[3];
      default:
        return moveTo[0];
    }
  };

  return (
    <ul className="d-flex list-unstyled text-body-tertiary fs-5 column-gap-5 mt-2">
      {dataMenu.map((item, index) => (
        <li key={index}>
          {location.pathname === "/" ? (
            <p
              onClick={() => {
                setActive(item.id);
                handleClick(handleItem(item.tag));
              }}
              className="text-decoration-none menu-navbar"
              style={{
                color: active === item.id ? "orange" : "inherit",
                fontWeight: active === item.id ? "600" : "normal",
                transition: "all 300ms",
              }}
            >
              {item.title}
            </p>
          ) : (
            <Link
              to={"/"}
              className="text-decoration-none menu-navbar"
              style={{
                color: active === item.id ? "orange" : "inherit",
                fontWeight: active === item.id ? "600" : "normal",
                transition: "all 300ms",
              }}
            >
              {item.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

const Navbar = ({ moveTo }) => {
  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector("nav");

      if (window.scrollY > 40) {
        nav.classList.add("bg-white");
      } else {
        nav.classList.remove("bg-white");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className="text-body-tertiary position-fixed w-100 py-4"
      style={{
        zIndex: "1000",
      }}
    >
      <Container className="d-flex justify-content-between">
        <img
          src="https://res.cloudinary.com/dr0lbokc5/image/upload/v1702054529/Group_33901_1_h7q9zb.png"
          className="logo-navbar"
          alt="logo"
        />
        <MenuNavbar moveTo={moveTo} />
      </Container>
    </nav>
  );
};

export default Navbar;
